const images = new Map();
const openings = new WeakMap();

function backgroundImages(menu) {
  return Array.from(
    getComputedStyle(menu).backgroundImage.matchAll(/url\(["']?(.*?)["']?\)/g),
    match => match[1]
  );
}

function loadImage(url) {
  if (images.has(url)) return images.get(url);
  const state = { ready: false };
  state.promise = new Promise(resolve => {
    const image = new Image();
    const finish = () => {
      state.ready = true;
      resolve();
    };
    image.onload = async () => {
      try { await image.decode(); } catch (_) { /* A loaded image can still be painted. */ }
      finish();
    };
    // A missing asset must not leave the menu unusable.
    image.onerror = finish;
    image.src = url;
  });
  images.set(url, state);
  return state;
}

function menuFor(toggle) {
  return toggle.parentElement?.querySelector(".dropdown-menu");
}

function preloadMenus() {
  for (const menu of document.querySelectorAll(".dropdown-menu")) {
    backgroundImages(menu).forEach(loadImage);
  }
}

document.addEventListener("turbo:load", preloadMenus);
document.addEventListener("turbo:frame-load", preloadMenus);

document.addEventListener("show.bs.dropdown", event => {
  const menu = menuFor(event.target);
  if (!menu) return;
  const opening = { visibility: menu.style.visibility };
  openings.set(menu, opening);
  // Popper sets placement after opening; that can select a different bubble image.
  menu.style.visibility = "hidden";
  requestAnimationFrame(async () => {
    const states = backgroundImages(menu).map(loadImage);
    await Promise.all(states.filter(state => !state.ready).map(state => state.promise));
    if (openings.get(menu) !== opening) return;
    menu.style.visibility = opening.visibility;
    openings.delete(menu);
  });
});

document.addEventListener("hidden.bs.dropdown", event => {
  const menu = menuFor(event.target);
  const opening = menu && openings.get(menu);
  if (!opening) return;
  menu.style.visibility = opening.visibility;
  openings.delete(menu);
});
